module.exports = __webpack_public_path__ + "img/collectionsroundtrans.e46f26d7.png";